import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Remove token from localStorage
        localStorage.removeItem("userToken");

        // Redirect to login page
        navigate("/");
    }, [navigate]);

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 text-lg font-semibold">
            Logging out...
        </div>
    );
};

export default Logout;
